(function () {
  if (!document.body.classList.contains('template-index')) return;

  /* Mobile menu — handled by luxlaria-brand.js (avoid duplicate toggle handlers) */

  /* Hero video autoplay + poster hide */
  document.querySelectorAll('[data-lv2-hero], .hero').forEach(function (hero) {
    var video = hero.querySelector('.hero-video');
    if (!video) return;
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function markPlaying() {
      hero.classList.add('video-is-playing');
    }

    video.addEventListener('playing', markPlaying);
    video.addEventListener('canplay', markPlaying);
    video.addEventListener('timeupdate', function onTime() {
      if (video.currentTime > 0.05) {
        markPlaying();
        video.removeEventListener('timeupdate', onTime);
      }
    });

    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        document.addEventListener('touchstart', function once() {
          video.play();
          document.removeEventListener('touchstart', once);
        }, { once: true, passive: true });
      });
    }

    if (!video.paused && video.readyState >= 2) {
      markPlaying();
    }
  });

  /* Best sellers carousel */
  document.querySelectorAll('.sellers-section').forEach(function (section) {
    var track = section.querySelector('[data-lv2-track]');
    var nav = section.querySelector('[data-lv2-carousel]');
    var mask = section.querySelector('.car-mask');
    if (!track || !nav || !mask) return;
    var pos = 0;

    function slide(dir) {
      var card = track.querySelector('.pc');
      if (!card) return;
      var cardW = card.offsetWidth + 14;
      var maxScroll = track.scrollWidth - mask.offsetWidth;
      pos = Math.max(0, Math.min(pos + dir * cardW, maxScroll));
      track.style.transform = 'translateX(-' + pos + 'px)';
    }

    nav.querySelectorAll('[data-lv2-slide]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        slide(parseInt(btn.getAttribute('data-lv2-slide'), 10));
      });
    });

    var touchStartX = 0;
    var touchStartPos = 0;
    mask.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartPos = pos;
    }, { passive: true });
    mask.addEventListener('touchmove', function (e) {
      if (!e.touches.length) return;
      var dx = touchStartX - e.touches[0].clientX;
      var maxScroll = track.scrollWidth - mask.offsetWidth;
      pos = Math.max(0, Math.min(touchStartPos + dx, maxScroll));
      track.style.transform = 'translateX(-' + pos + 'px)';
    }, { passive: true });
  });

  /* Category carousel (manual scroll — skipped when marquee mode is active) */
  document.querySelectorAll('.cat-carousel-section:not(.cat-carousel-section--marquee)').forEach(function (section) {
    var catMask = section.querySelector('[data-lv2-cat-mask]');
    var catTrack = section.querySelector('[data-lv2-cat-track]');
    var catNav = section.querySelector('[data-lv2-cat-nav]');
    if (!catMask || !catTrack || !catNav) return;

    var catPos = 0;

    function getGap() {
      var styles = window.getComputedStyle(catTrack);
      return parseFloat(styles.columnGap || styles.gap) || 16;
    }

    function getStep() {
      var card = catTrack.querySelector('.cat-tile');
      return card ? card.getBoundingClientRect().width + getGap() : 0;
    }

    function getMaxScroll() {
      return Math.max(0, catTrack.scrollWidth - catMask.clientWidth);
    }

    function applyPosition() {
      catTrack.style.transform = 'translate3d(-' + catPos + 'px, 0, 0)';
    }

    function updateNavState() {
      var max = getMaxScroll();
      catNav.querySelectorAll('[data-lv2-cat-slide]').forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-lv2-cat-slide'), 10);
        var atEdge = dir < 0 ? catPos <= 1 : catPos >= max - 1;
        btn.disabled = max > 0 && atEdge;
        btn.setAttribute('aria-disabled', atEdge ? 'true' : 'false');
      });
    }

    function slideCat(dir) {
      var step = getStep();
      if (!step) return;
      catPos = Math.max(0, Math.min(catPos + dir * step, getMaxScroll()));
      applyPosition();
      updateNavState();
    }

    catNav.querySelectorAll('[data-lv2-cat-slide]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        slideCat(parseInt(btn.getAttribute('data-lv2-cat-slide'), 10));
      });
    });

    var dragging = false;
    var startX = 0;
    var startPos = 0;

    catMask.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragging = true;
      startX = e.pageX;
      startPos = catPos;
      catMask.style.cursor = 'grabbing';
      catTrack.style.transition = 'none';
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = startX - e.pageX;
      catPos = Math.max(0, Math.min(startPos + dx, getMaxScroll()));
      applyPosition();
    });

    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      catMask.style.cursor = 'grab';
      catTrack.style.transition = '';
      updateNavState();
    });

    var catTouchStartX = 0;
    var catTouchStartPos = 0;

    catMask.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      catTouchStartX = e.touches[0].clientX;
      catTouchStartPos = catPos;
      catTrack.style.transition = 'none';
    }, { passive: true });

    catMask.addEventListener('touchmove', function (e) {
      if (!e.touches.length) return;
      var dx = catTouchStartX - e.touches[0].clientX;
      catPos = Math.max(0, Math.min(catTouchStartPos + dx, getMaxScroll()));
      applyPosition();
    }, { passive: true });

    catMask.addEventListener('touchend', function () {
      catTrack.style.transition = '';
      updateNavState();
    });

    function refreshCarousel() {
      catPos = Math.min(catPos, getMaxScroll());
      applyPosition();
      updateNavState();
    }

    window.addEventListener('resize', refreshCarousel);
    catTrack.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', refreshCarousel, { once: true });
      }
    });

    refreshCarousel();
  });

  /* Stats entrance animation */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '0';
          e.target.style.transform = 'translateY(20px)';
          setTimeout(function () {
            e.target.style.transition = 'all 0.65s ease';
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
          }, 60 + Math.random() * 280);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.stat-num').forEach(function (n) { io.observe(n); });
  }

  /* Video strip autoplay */
  document.querySelectorAll('[data-lv2-video-strip]').forEach(function (section) {
    var track = section.querySelector('[data-lv2-video-track]');
    if (!track) return;

    /* Play videos when visible; pause when off-screen */
    var videos = track.querySelectorAll('.vc-video');
    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    });

    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          var card = video.closest('.vc-card');
          if (entry.isIntersecting && entry.intersectionRatio > 0.45) {
            card && card.classList.add('is-playing');
            video.play().catch(function () {});
          } else {
            card && card.classList.remove('is-playing');
            video.pause();
          }
        });
      }, { threshold: [0, 0.6, 0.9] });
      videos.forEach(function (v) { vio.observe(v); });
    }

    track.querySelectorAll('.vc-card').forEach(function (card) {
      var video = card.querySelector('.vc-video');
      if (!video) return;
      card.addEventListener('mouseenter', function () {
        video.play().catch(function () {});
        card.classList.add('is-playing');
      });
      card.addEventListener('mouseleave', function () {
        var rect = card.getBoundingClientRect();
        var centered = rect.left + rect.width * 0.5 > 0 && rect.right < window.innerWidth;
        if (!centered) {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
    });
  });

  /* Header scroll shadow */
  var header = document.querySelector('header.header.luxlaria-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }
})();
